import React from "react";

// Parse inline **bold** and [text](url) into React nodes (no dangerouslySetInnerHTML).
function parseInline(text, keyPrefix) {
  const nodes = [];
  const regex = /(\*\*([^*]+)\*\*)|(\[([^\]]+)\]\((https?:\/\/[^\s)]+)\))/g;
  let last = 0;
  let m;
  let i = 0;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > last) nodes.push(text.slice(last, m.index));
    if (m[1]) {
      nodes.push(<strong key={`${keyPrefix}-b-${i}`} className="font-semibold text-ink">{m[2]}</strong>);
    } else if (m[3]) {
      nodes.push(
        <a
          key={`${keyPrefix}-a-${i}`}
          href={m[5]}
          target="_blank"
          rel="noopener noreferrer"
          className="link-underline text-ink underline decoration-brass/60 underline-offset-4 hover:text-brass transition-colors"
        >
          {m[4]}
        </a>
      );
    }
    last = m.index + m[0].length;
    i += 1;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes;
}

// Renders an array of paragraph strings.
// - A paragraph starting with "> " becomes a pull-quote.
// - Supports **bold** and [text](url) inline.
export const RichParagraphs = ({ paragraphs, lead = false }) => {
  let firstBodyRendered = false;
  return (
    <>
      {paragraphs.map((raw, i) => {
        const p = (raw || "").trim();
        if (!p) return null;
        if (p.startsWith(">")) {
          const quote = p.replace(/^>\s?/, "");
          return (
            <blockquote
              key={i}
              className="my-10 border-l-2 border-brass pl-6 md:pl-8 font-serif text-2xl md:text-3xl text-ink leading-[1.35] italic"
            >
              {parseInline(quote, `q${i}`)}
            </blockquote>
          );
        }
        const isLead = lead && !firstBodyRendered;
        firstBodyRendered = true;
        return (
          <p
            key={i}
            className={
              isLead
                ? "font-serif text-2xl md:text-3xl text-ink/90 leading-[1.4] mb-10"
                : "text-lg text-ink/70 font-light leading-relaxed mb-8"
            }
          >
            {parseInline(p, `p${i}`)}
          </p>
        );
      })}
    </>
  );
};
